/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalReauthSubmissionListEntry } from './PalReauthSubmissionListEntry';
import {
    PalReauthSubmissionListEntryFromJSON,
    PalReauthSubmissionListEntryFromJSONTyped,
    PalReauthSubmissionListEntryToJSON,
} from './PalReauthSubmissionListEntry';

/**
 * 
 * @export
 * @interface FindAllPalReauthSubmissionsResponse
 */
export interface FindAllPalReauthSubmissionsResponse {
    /**
     * 
     * @type {Array<PalReauthSubmissionListEntry>}
     * @memberof FindAllPalReauthSubmissionsResponse
     */
    data: Array<PalReauthSubmissionListEntry>;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalReauthSubmissionsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalReauthSubmissionsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalReauthSubmissionsResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllPalReauthSubmissionsResponse
     */
    has_next: boolean;
    /**
     * User lookup map keyed by user_id. Each value matches the LeadAssignmentUser shape. Typed as an open object because the openapi-generator's TypeScript template emits broken FromJSON for typed-additionalProperties Records; consumers cast at use site.
     * @type {{ [key: string]: any; }}
     * @memberof FindAllPalReauthSubmissionsResponse
     */
    users_sidecar?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FindAllPalReauthSubmissionsResponse interface.
 */
export function instanceOfFindAllPalReauthSubmissionsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllPalReauthSubmissionsResponseFromJSON(json: any): FindAllPalReauthSubmissionsResponse {
    return FindAllPalReauthSubmissionsResponseFromJSONTyped(json, false);
}

export function FindAllPalReauthSubmissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalReauthSubmissionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PalReauthSubmissionListEntryFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'users_sidecar': !exists(json, 'users_sidecar') ? undefined : json['users_sidecar'],
    };
}

export function FindAllPalReauthSubmissionsResponseToJSON(value?: FindAllPalReauthSubmissionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PalReauthSubmissionListEntryToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
        'users_sidecar': value.users_sidecar,
    };
}

